module.exports = __webpack_public_path__ + "media/images/page/labo-04-ad4d3b35c8e0ff58457fd12239e4ac0d.webp";